import { useMemo } from 'react';
import IconCancel from '@creditflowresearch/uilib/Icon/IconCancel';
import IconButton from '@creditflowresearch/uilib/IconButton';
import { useScorecardContext } from '@/creditflowresearch/application/League/Scorecard/ScorecardContext';

import styles from '@/creditflowresearch/ui/components/league/Scorecard/SelectedPeriodTag/selectedPeriodTag.module.scss';

const SelectedPeriodTag = () => {
  const { state: { selectedPeriod, data: { categories = [] } }, resetSelectedPeriod } = useScorecardContext();

  const closePeriod = () => resetSelectedPeriod();

  const category = useMemo(
    () => (
      selectedPeriod.categoryId ? categories.find((category) => category.id === selectedPeriod.categoryId) : null
    ),
    [categories, selectedPeriod.categoryId],
  );

  const subCategory = useMemo(
    () => (
      selectedPeriod.subCategoryId
        && category
        ? category.subcategories.find((subCategory) => subCategory.id === selectedPeriod.subCategoryId) : null
    ),
    [category, selectedPeriod.subCategoryId],
  );

  if (!selectedPeriod.name || !category) {
    return null;
  }

  const subcategoryName = selectedPeriod.subCategoryId && subCategory ? `: ${ subCategory.name }` : '';
  const periodName = `${ category.name }${ subcategoryName } - ${ selectedPeriod.name }`;

  return (
    <span className={ styles.container }>
      <span className={ styles.periodName }>
        { periodName }
      </span>
      <IconButton
        icon={ <IconCancel className={ styles.icon } /> }
        className={ styles.closeButton }
        onClick={ closePeriod }
        ariaLabel={ `Remove ${ periodName }` }
        dataTest="selectedPeriodTagRemove"
      />
    </span>
  );
};

export default SelectedPeriodTag;
